import React, { Component, Fragment } from "react";
import { Card } from "antd";
import ruleref from '../../style/images/game/rules/e.png'
export default class Rules extends Component {
  render() {
    return (
      <Fragment>
        <Card  className = 'wow' title = 'Rules'  headStyle = {{textAlign: 'right'}}>
          {/* <div className="row">
            <div className="col-xs-6">
              <div className="row">
                <div className="col-xs-6">
                  <h1>HOW TO PLAY:</h1>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure{" "}
                  </p>
                </div>
                <div className="col-xs-6">
                  <img />>
                </div>
              </div>
            </div>
            <div className="col-xs-6">
              <p>
                lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>

              <h1>How the score is calculated:</h1>
              <p>
                iDolor in reprehenderit in voluptate velit esse cillum dolore eu
                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                proident. deserunt mollit anim id est laborum. Sed ut
                perspiciatis unde omnis iste natus error nesciunt. Neque porro
                quisquam est, qui dolorem ipsum quia dolor sit amet,
                consectetur, adipisci velit, sed quia non numquam eius modi
                tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem.
              </p>
            </div>
          </div> */}
          <div className ="row">
      <div className ="col-xs-12">
      <img style = {{width:'100%'}}src= {ruleref}/>
      </div>
       
      </div>
          
        </Card>
      </Fragment>
    );
  }
}
